import React, { useState } from 'react';
import { KeyRound, Eye, EyeOff, Loader2, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChangePasswordModal({ token, onDone }) {
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPwd.length < 6) { toast.error('Minimo 6 caratteri'); return; }
    if (newPwd !== confirmPwd) { toast.error('Le password non coincidono'); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { token, new_password: newPwd });
      toast.success('Password aggiornata!');
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore nel cambio password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.4)' }}>
      <div className="w-full max-w-md mx-4 rounded-2xl p-8 shadow-2xl" style={{ background: '#FAF7F4' }}>
        <div className="flex flex-col items-center mb-6">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3"
            style={{ background: 'rgba(226,114,91,0.12)' }}>
            <ShieldCheck size={24} style={{ color: '#E2725B' }} />
          </div>
          <h2 className="text-xl font-bold text-gray-800" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Cambia la password
          </h2>
          <p className="text-sm text-gray-500 mt-1 text-center">
            Stai usando la password predefinita. Scegli una password personale.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">Nuova password</label>
            <div className="relative">
              <input
                data-testid="new-password-input"
                type={showNew ? 'text' : 'password'}
                value={newPwd}
                onChange={e => setNewPwd(e.target.value)}
                placeholder="Minimo 6 caratteri"
                className="w-full px-4 py-3 pr-10 text-sm rounded-xl border focus:outline-none transition-all"
                style={{ borderColor: '#D9D2C8', background: 'white' }}
                onFocus={e => e.target.style.borderColor = '#E2725B'}
                onBlur={e => e.target.style.borderColor = '#D9D2C8'}
                autoFocus
              />
              <button type="button" onClick={() => setShowNew(v => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                {showNew ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">Conferma password</label>
            <div className="relative">
              <input
                data-testid="confirm-password-input"
                type={showConfirm ? 'text' : 'password'}
                value={confirmPwd}
                onChange={e => setConfirmPwd(e.target.value)}
                placeholder="Ripeti la password"
                className="w-full px-4 py-3 pr-10 text-sm rounded-xl border focus:outline-none transition-all"
                style={{ borderColor: '#D9D2C8', background: 'white' }}
                onFocus={e => e.target.style.borderColor = '#E2725B'}
                onBlur={e => e.target.style.borderColor = '#D9D2C8'}
              />
              <button type="button" onClick={() => setShowConfirm(v => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                {showConfirm ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>

          <button
            data-testid="save-new-password-btn"
            type="submit"
            disabled={saving}
            className="w-full py-3 text-sm font-semibold text-white rounded-xl transition-all mt-2"
            style={{ background: '#E2725B', opacity: saving ? 0.7 : 1 }}
          >
            {saving ? <span className="flex items-center justify-center gap-2"><Loader2 size={14} className="animate-spin" />Salvataggio...</span> : 'Salva password'}
          </button>
        </form>
      </div>
    </div>
  );
}
